<template>
  <div class="wbs-root">
    <AppBarraSuperior
      :items="items"
      v-on:alterar-instituicao="alterarInstituicao"
    />
    <AppMenuBarraSuperior
      :items="items"
      v-on:alterar-instituicao="alterarInstituicao"
    />
    <div class="wbs-site__body">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
import AppBarraSuperior from "../components/layout/AppBarraSuperior.vue";
import AppMenuBarraSuperior from "../components/layout/AppMenuBarraSuperior.vue";

function linksBarraSuperior() {
  let items = [
    {
      text: "Buscar Estudo",
      icon: "mdi-magnify",
      route: "/buscarEstudos",
      id: "menuSuperior-buscarEstudos"
    },
    {
      text: "Lixeira",
      icon: "mdi-delete",
      route: "/lixeira",
      id: "menuSuperior-lixeira"
    },
    {
      text: "Administrativo",
      icon: "mdi-lock",
      route: "/administrativo",
      id: "menuSuperior-administrativo"
    }
  ];

  return items;
}

export default {
  name: "index",
  components: {
    AppBarraSuperior,
    AppMenuBarraSuperior
  },
  computed: {
    esconderRodape() {
      return this.$route.meta.esconderRodape;
    }
  },
  data() {
    return {
      modal: false,
      items: linksBarraSuperior()
    };
  },
  methods: {
    alterarInstituicao() {
      this.modal = true;
    }
  }
};
</script>
<style lang="sass"></style>
